import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { times } from 'lodash/fp';

import { ReactComponent as Arrow } from '../../../../../svgs/leftarrow.svg';
import { ReactComponent as Cross } from '../../../../../svgs/cross.svg';
import styles from './daySelector.module.css';

const DaySelector = ({
  onClickLeft,
  onClickRight,
  mainDay,
  selectedDoctor,
  clearSelect,
  showChangePatient,
  patientChanged,
}) => (
  <div className={styles.daySelector}>
    {showChangePatient && (
      <div className={styles.changePatient} onClick={patientChanged}>
        Change Patient
      </div>
    )}
    {selectedDoctor && (
      <div className={styles.selectedDoc}>
        {selectedDoctor}
        <Cross onClick={clearSelect} className={styles.cross} />
      </div>
    )}
    <div className={styles.arrowContainer} onClick={onClickLeft}>
      <Arrow className={styles.arrowIconLeft} />
    </div>
    <div className={styles.dayContainer}>
      {times(i => (
        <div className={styles.dayUnit} key={i}>
          <div className={styles.dow}>
            {moment(mainDay)
              .add(i, 'days')
              .format('dddd ')
              .slice(0, 3)}
          </div>
          <div className={styles.month}>
            {moment(mainDay)
              .add(i, 'days')
              .format('D MMM')}
          </div>
        </div>
      ))(5)}
    </div>
    <div className={styles.arrowContainer} onClick={onClickRight}>
      <Arrow className={styles.arrowIcon} />
    </div>
  </div>
);
DaySelector.propTypes = {
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  mainDay: PropTypes.instanceOf(moment).isRequired,
  clearSelect: PropTypes.func.isRequired,
  selectedDoctor: PropTypes.string,
};

export default DaySelector;
